export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const RESET_CART = "RESET_CART";
export const USER_ORDERS = "USER_ORDERS";
// code refactoring
export const USER_DETAILS = "USER_DETAILS";
export const SET_PRODUCT_MINIMUM_VALUE = "SET_PRODUCT_MINIMUM_VALUE";



export const RESONATE_EXCLUSIVE_LIST="RESONATE_EXCLUSIVE_LIST";
export const RESONATE_EXCLUSIVE_FILTER="RESONATE_EXCLUSIVE_FILTER";
export const SHOP_ONLINE_LIST="SHOP_ONLINE_LIST";
export const SHOP_ONLINE_FILTER="SHOP_ONLINE_FILTER";
export const ADD_ITEMS_TO_CART="ADD_ITEMS_TO_CART";
export const SET_QR_CODE="SET_QR_CODE";
export const SET_USER_ID="SET_USER_ID";